import * as React from "react";
import { cx } from "@linaria/core";

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  chapters: Array<Chapter>;
  selectedChapter?: number;
  onSelectChapter?: (i: number) => void;
}
interface Chapter {
  name?: string;
  values: Array<string>;
}
function ColorBook(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const {
    chapters,
    selectedChapter,
    onSelectChapter,
    className,
    ...rest
  } = props;
  return <Root ref={ref} {...rest} className={cx(className, "rmv2wrl")}>
      {chapters.map(({
      name,
      values
    }, i) => <div key={i} style={{
      gridColumn: i + 1
    }}>
          <div className={cx(chapter, i === selectedChapter && activeChapter)} onClick={() => {
        if (onSelectChapter) {
          onSelectChapter(i);
        }
      }}>
            {values.map(value => <div key={value} style={{
          background: value
        }} className={"d1l94wnr"} />)}
          </div>
          {name && <div className={cx("d1uopbb", i === selectedChapter && "d1vwzhoa")}>
              {name}
            </div>}
        </div>)}
    </Root>;
}
export default React.forwardRef(ColorBook);
const chapter = "c1xqhu04";
const activeChapter = "a1y0tcvx";

require("./ColorBook.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./ColorBook.tsx");